module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/sCKrdG/tc-custom/9781685503109.jpg?1723403955746",
      "alt": "This image is the cover for the book The Ishcrin Affair"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Ishcrin Affair\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Clem Turner is pretty sure nothing else can go wrong. Assigned by the head of his museum to check out a possible acquisition, his train ride from Chicago to Duluth has been full of problems -- lost luggage, food poisoning, and now an unscheduled stop in the middle of nowhere, Wisconsin. Hoping for a bit of distraction, he decides to check out the local fair, only to run right into a different sort of predicament."), _c('br'), _c('br'), _vm._v("The 1890s aren’t a great time to fall for another man, but with Anton Hess it’s hard to resist. An adventurer and businessman, Anton has captured the legendary ishcrin, a beast with wings, spines, and a nasty disposition, and he’s charging people to see it. For the nickel admission, though, Clem gets much more than he bargained for, and faces the prospect of the greatest disaster of his journey yet -- a broken heart.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gareth Vaughn\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0